import { render } from "./GraphicProducts.vue?vue&type=template&id=98d5f4e4&scoped=true"
import script from "./GraphicProducts.vue?vue&type=script&lang=js"
export * from "./GraphicProducts.vue?vue&type=script&lang=js"

import "./GraphicProducts.vue?vue&type=style&index=0&id=98d5f4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d5f4e4"]])

export default __exports__